import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./slider.css";

const Slider = () => {
  return (
    <section className="slider-wrapper">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        loop={true}
        slidesPerView={1}
        autoplay={{
          delay: 3000,
          disableOnInteraction: true, // pause on click & touch
        }}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            slidesPerView: 1,
          },
        }}
      >
        <SwiperSlide>
          <div className="slider-card">
            <img src="/img/desktop/desktopbanner.webp"className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
            <img src="/img/mobile/mobilepackage.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="slider-card">
            <img src="/img/desktop/desktophotel.webp"className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
            <img src="/img/mobile/mobilebanner.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="slider-card">
            <img src="/img/desktop/desktopguide.webp" className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
            <img src="/img/mobile/mobilepackage.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-card">
          <img src="/img/desktop/desktoprent.webp" className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
         
            <img src="/img/mobile/mobilerent.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-card">
          <img src="/img/desktop/desktopnepal.webp" className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
            <img src="/img/mobile/hireguide.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-card">
          <img src="/img/desktop/desktophotel.webp" className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
            <img src="/img/mobile/mobileexplore.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-card">
          <img src="/img/desktop/desktoppackage.webp" className="desktop-banner" fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
            <img src="/img/mobile/mobilehotel.webp" className="mobile-banner"fetchpriority="high" /* Modern browser directive to prioritize this network request */
      loading="eager"      /* Explicitly forces immediate download */
      decoding="sync"/>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default Slider;
